<p-toast />
<p-confirmPopup />
<div class="layout-topbar">
    
    <a class="layout-topbar-logo" routerLink="/assignment-employee">
        <img src="assets/layout/images/{{layoutService.config().colorScheme === 'light' ? 'logo-claro-blanco' : 'logo-claro-blanco'}}.svg" alt="logo">
            <span style="color: white; font-size: 1.7rem; padding-top: 17px;">Parqueos</span>
    </a>

    <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button" (click)="layoutService.showProfileSidebar()">
        <i class="pi pi-ellipsis-v"></i>
    </button>

    <div #topbarmenu class="layout-topbar-menu" [ngClass]="{'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible}">
        <p-button label="{{this.user}}" severity="danger" icon="pi pi-user" class="mr-3"  />
        <p-button label="{{ this.ubicacionParqueo }}" icon="pi pi-map-marker" severity="danger" class="mr-3" />
        <p-button label="Cerrar Sesión"  severity="danger" (onClick)="confirmLogout($event)" icon="pi pi-sign-out" />
    </div>
    
</div>